<template>
    <div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                height="385"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :row-key="getRowKeys"
                :row-class-name="rowClassName"
                :default-expand-all="expend"
        >
<!--           :row-key="(row) => row.$index" -->
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    type="expand"
                    :label="$t('saleInvoicing_details')"
                    show-overflow-tooltip>
                <template slot-scope="props">
                    <el-table
                            border
                            :data="props.row.subDetails"
                            class="child-table"
                            style="width: 100%"
                            :header-cell-style="{background:'#eef1f6',color:'grey'}"
                    >
                        <!--:show-header="false"-->
                        <el-table-column
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="i_type"
                                :label="$t('saleInvoicing_type')"
                                show-overflow-tooltip
                                width="95">
                            <template slot-scope="scope">
                                <span >{{scope.row.i_type==0?$t('saleInvoicing_outbound'):(scope.row.i_type==1?$t('saleInvoicing_pre_release_from_warehouse'):(scope.row.i_type==2?$t('saleInvoicing_return_warehousing'):(scope.row.i_type==3?$t('saleInvoicing_tusun'):'')))}}</span>
                                <!-- 无4(scope.row.i_type==4?$t('saleInvoicing_jushou'):'')-->
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="vc_pzname"
                                :label="$t('saleInvoicing_variety')"
                                show-overflow-tooltip
                                width="200">
                        </el-table-column>
                        <el-table-column
                                prop="f_ordernum_ky"
                                :label="$t('saleInvoicing_order_availability')"
                                show-overflow-tooltip
                                width="100"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_ordernum"
                                :label="$t('saleInvoicing_the_quantity_of_this_invoicing_order')"
                                show-overflow-tooltip
                                width="135"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_invoicenum"
                                :label="$t('saleInvoicing_the_quantity_invoiced_this_time')"
                                show-overflow-tooltip
                                width="135"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_kpprice_sell"
                                :label="$t('saleInvoicing_invoice_unit_price')"
                                show-overflow-tooltip
                                align="right"
                                width="135">
                        </el-table-column>
                        <!--<el-table-column
                                prop="f_invoice_amount"
                                label="发票金额"
                                show-overflow-tooltip
                                align="right"
                                width="135">
                        </el-table-column>-->
                        <el-table-column
                                prop="f_invoice_amount_notax"
                                :label="$t('saleInvoicing_invoice_tax_free_amount')"
                                show-overflow-tooltip
                                align="right"
                                width="135">
                        </el-table-column>
                        <el-table-column
                                prop="f_sl"
                                :label="$t('saleInvoicing_tax_rate')"
                                show-overflow-tooltip
                                align="right"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="f_invoice_amount_tax"
                                :label="$t('saleInvoicing_tax_amount')"
                                show-overflow-tooltip
                                align="right"
                                width="135">
                        </el-table-column>
                        <el-table-column
                                prop="f_reject_num"
                                :label="$t('saleInvoicing_rejected_quantity')"
                                show-overflow-tooltip
                                width="90"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_ordernum_used"
                                :label="$t('saleInvoicing_number_of_invoiced_orders')"
                                show-overflow-tooltip
                                width="135"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_outbound_num"
                                :label="$t('saleInvoicing_outbound_quantity')"
                                show-overflow-tooltip
                                width="100"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="f_transitloss_num"
                                :label="$t('saleInvoicing_loss_in_transit')"
                                show-overflow-tooltip
                                width="100"
                                align="right">
                        </el-table-column>
                        <el-table-column
                                prop="dt_ywtime"
                                :label="$t('saleInvoicing_business_hours')"
                                show-overflow-tooltip
                                width="115"
                                align="right">
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    :label="$t('saleInvoicing_customer')"
                    min-width="180">
            </el-table-column>
            <el-table-column
                    prop="i_title_type"
                    :label="$t('saleInvoicing_invoice_title')"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <el-select style="width: 80px"  @change="changeTt"  class="marr4" v-model="scope.row.i_title_type" size="mini" filterable >
                        <el-option
                                v-for="item in titleType"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                    <!--<span v-else>{{scope.row.i_title_type==1?'企业':'个人'}}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_invoice_type"
                    :label="$t('saleInvoicing_invoice_leixing')"
                    show-overflow-tooltip
                    min-width="170">
                <template slot-scope="scope">
                    <el-select style="width: 140px" @change="changeInvoice(scope.row)" class="marr4" v-model="scope.row.i_invoice_type" size="mini" filterable >
                        <el-option
                                v-for="item in kplxData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                    <!--<span v-else>{{scope.row.vc_invoice_type}}</span>-->
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_invoice_type"
                    label="发票类型"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>-->
            <!--<el-table-column
                    prop="i_istemp"
                    label=""
                    show-overflow-tooltip
                    width="95">
                <template slot-scope="scope">
                    <span :class="scope.row.i_istemp==1?'boxyu box marr4':''">{{scope.row.i_istemp==1?'临':''}}</span>
                    <span v-if="scope.row.i_istemp==1" :class="scope.row.i_istemp_over==1?'boxyu boxbu green':'boxyu boxbu'">{{scope.row.i_istemp_over==1?'已补':'未补'}}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    prop="vc_xcode"
                    :label="$t('saleInvoicing_sales_number')"
                    show-overflow-tooltip
                    min-width="155">
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_kpname_sell"
                    :label="$t('saleInvoicing_invoice_item_name')"
                    show-overflow-tooltip
                    min-width="110">
                <template slot-scope="scope" >
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_kpname_sell">
                    </el-input>
                    <!--<span v-else>{{scope.row.vc_kpname_sell}}</span>-->
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_kpname_sell"
                    label="开票品名"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>-->
            <el-table-column
                    prop="vc_pzspecs"
                    :label="$t('saleInvoicing_specification_model')"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_kpbzstyle_sell"
                    :label="$t('saleInvoicing_invoice_specifications')"
                    show-overflow-tooltip
                    width="140">
                <template slot-scope="scope" >
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_kpbzstyle_sell">
                    </el-input>
                    <!--<span v-else>{{scope.row.vc_kpbzstyle_sell}}</span>-->
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_kpbzstyle_sell"
                    label="开票规格"
                    show-overflow-tooltip
                    min-width="120">
            </el-table-column>-->
            <el-table-column
                    prop="vc_unit"
                    :label="$t('saleInvoicing_unit')"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_kpunit_sell"
                    label="开票单位"
                    show-overflow-tooltip
                    width="80">
            </el-table-column>-->
            <el-table-column
                    prop="vc_kpunit_sell"
                    :label="$t('saleInvoicing_billing_entity')"
                    show-overflow-tooltip
                    width="128">
                <template slot-scope="scope">
                    <el-select style="width: 100px" @focus="getUnits(scope.row)"  @change="changeData(scope.row)"  class="marr4" v-model="scope.row.vc_kpunit_sell" size="mini" clearable filterable placeholder="请选择开票单位">
                        <el-option
                                v-for="item in unitData"
                                :key="item.vc_unitsconvert"
                                :label="item.vc_unitsconvert"
                                :value="item.vc_unitsconvert">
                        </el-option>
                    </el-select>
                    <!--<span v-else>{{scope.row.vc_kpunit_sell}}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_kpnum_sell"
                    :label="$t('saleInvoicing_invoice_quantity')"
                    show-overflow-tooltip
                    width="125"
                    align="right">
                <template slot-scope="scope" >
                    <el-input-number  @change="changenum(scope.row)" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"  size="mini" v-model="scope.row.f_kpnum_sell" ></el-input-number>
                    <!--<span v-else>{{scope.row.f_kpnum_sell}}</span>-->
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="f_kpnum_sell"
                    label="开票数量"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>-->
            <el-table-column
                    prop="f_price"
                    :label="$t('saleInvoicing_order_unit_price')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('saleInvoicing_order_quantity_outbound_quantity_signed_receipt_quantity')"
                    show-overflow-tooltip
                    min-width="140"
                    align="right">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{scope.row.f_kdnum+'/'+scope.row.f_outnum+'/'+scope.row.f_signnum+'/'+scope.row.f_backnum}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('saleInvoicing_pre_shipment_quantity_shipped_and_verified_quantity')"
                    show-overflow-tooltip
                    min-width="200"
                    align="right">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{scope.row.f_ycknum+'/'+scope.row.f_yckhxnum}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_kycknum"
                    :label="$t('saleInvoicing_available_for_shipment_quantity')"
                    show-overflow-tooltip
                    min-width="111"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('saleInvoicing_pending_invoicing_order_volume')"
                    show-overflow-tooltip
                    min-width="100"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_invoicednum"
                    :label="$t('saleInvoicing_number_of_invoiced_orders')"
                    show-overflow-tooltip
                    min-width="110"
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_amount"
                    :label="$t('saleInvoicing_kaipiao_amount')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_note"
                    label="发票备注"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_thtype"
                    :label="$t('saleInvoicing_delivery_method')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kduname"
                    :label="$t('saleInvoicing_business')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_creditcode"
                    :label="$t('saleInvoicing_customer_taxpayer_identification_number')"
                    show-overflow-tooltip
                    min-width="200">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_adress"
                    label="地址、电话"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.vc_address+' '+scope.row.vc_tel }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="开户行及帐号"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.vc_bank+' '+scope.row.vc_bank_account }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_email"
                    label="发票接收邮箱"
                    show-overflow-tooltip
                    min-width="150">
            </el-table-column>-->
            <el-table-column
                    prop="vc_adress"
                    :label="$t('saleInvoicing_address')"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_address">
                    </el-input>
                    <!--<span v-else style="margin-left: 10px">{{ scope.row.vc_address}}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_tel"
                    :label="$t('saleInvoicing_telephone')"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_tel">
                    </el-input>
                    <!--<span v-else style="margin-left: 10px">{{scope.row.vc_tel }}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    :label="$t('saleInvoicing_bank_of_deposit')"
                    show-overflow-tooltip
                    min-width="120">
                <template slot-scope="scope">
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_bank">
                    </el-input>
                    <!--<span v-else style="margin-left: 10px">{{ scope.row.vc_bank}}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    :label="$t('saleInvoicing_bank_account_number')"
                    show-overflow-tooltip
                    min-width="150">
                <template slot-scope="scope">
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_bank_account">
                    </el-input>
                    <!--<span v-else style="margin-left: 10px">{{scope.row.vc_bank_account }}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_email"
                    :label="$t('saleInvoicing_email')"
                    show-overflow-tooltip
                    min-width="170">
                <template slot-scope="scope">
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_email">
                    </el-input>
                    <!--<span v-else style="margin-left: 10px">{{scope.row.vc_email }}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_note"
                    :label="$t('form_notes')"
                    show-overflow-tooltip
                    width="100">
                <template slot-scope="scope">
                    <el-input class="wid100" size="mini"  v-model="scope.row.vc_note">
                    </el-input>
                    <!--<span v-else style="margin-left: 10px">{{scope.row.vc_note }}</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="dt_yjdhtime"
                    :label="$t('saleInvoicing_estimated_arrival_time')"
                    show-overflow-tooltip
                    min-width="100">
            </el-table-column>

        </el-table>
        <!--<el-pagination
                class="flex_e mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[15, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>-->
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm"  :class="baseerp+'btn'" size="mini">{{$t('saleInvoicing_save')}}</el-button>
            <el-button @click="cancel" size="mini">{{$t('saleInvoicing_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {},
        props: {
            addData: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                baseerp: "",
                file_url: '',
                file_root:"",
                baseApp:"",
                baseVersion:"",
                i_fytype:1,
                loading:false,
                dt_startdate:'',
                dt_enddate:'',
                vc_search:"",
                valuetime:'',
                i_over:null,
                overData:[{i_id:null,vc_name:this.$t('saleInvoicing_all')},{i_id:0,vc_name:this.$t('saleInvoicing_in_progress')},{i_id:1,vc_name:this.$t('saleInvoicing_closed')}],
                getRowKeys(row){
                    return row.i_pzid+row.vc_xcode
                },
                mid: 0,
                expend:false,
                showTable:true,
                tableData: [],
                multipleSelection: [],
                pageSize: 30,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
                titleType:[{i_id:1,vc_name:this.$t('saleInvoicing_enterprise')},{i_id:2,vc_name:this.$t('saleInvoicing_individual')}],
                kpData:[],
                kplxData:[],
                unitData:[],
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        mounted() {
            //this.getfMou();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("addData", this.addData);
            //return
            //this.i_fytype=this.addData.i_fytype;
            console.log(this.addData.i_state,'this.addData.i_state');
            console.log(this.addData.i_invoice_source,'this.addData.i_invoice_source');
            console.log(this.addData.i_order_source,'this.addData.i_order_source');
            this.invoicetype();
            this.refreshTable();
            this.getOrders();
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
        },
        methods: {
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            changeTt(e){
                //console.log('e',e)
                this.i_title_type=e;
                this.kplxData = [];
                this.kplxData = this.i_title_type==2?this.kpData.filter(kp=>kp.i_isspec==0):this.kpData
                //console.log(this.kplxData ,'this.kplxData--- ')
            },
            //开票类型
            async invoicetype(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.invoicetype(param);
                if (res.code == 1) {
                    this.kpData = res.data.list;
                    this.kplxData = this.kpData;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeInvoice(e){
                //console.log(this.kplxData,'this.kplxData');
                //console.log(e,'e');
                this.tableData[e.index].i_invoice_type=e.i_invoice_type;
                let choo = this.kplxData.filter(item=>{
                    return item.i_id == e.i_invoice_type
                });
                //console.log(choo,'choo');
                if(choo.length>0){
                    //this.i_isspec=choo[0].i_isspec;
                    this.tableData[e.index].vc_invoice_type=choo[0].vc_name;
                }else{
                    //this.i_isspec=null;
                    this.tableData[e.index].vc_invoice_type='';
                }
            },
            changenum(e){
                //console.log('e',e)
                if(e.f_kpnum_sell>this.tableData[e.index].yskpnum||e.f_kpnum_sell==0){
                    this.$message.error(this.$t('saleInvoicing_the_invoiced_quantity_cannot_exceed_the_quantity_to_be_invoiced')+this.tableData[e.index].yskpnum+'!');
                    this.$nextTick(() => {
                        this.tableData[e.index].f_kpnum_sell=this.tableData[e.index].yskpnum;
                        this.tableData[e.index].f_num=(this.tableData[e.index].f_kpnum_sell/this.tableData[e.index].f_bl).toFixed(this.$setPrecision.quantityPrecision);
                        this.tableData[e.index].ysordnum=(this.tableData[e.index].f_kpnum_sell/this.tableData[e.index].f_bl).toFixed(this.$setPrecision.quantityPrecision);
                        this.tableData[e.index].f_amount=(this.tableData[e.index].f_num*this.tableData[e.index].f_price).toFixed(this.$setPrecision.quantityPrecision);


                        this.handleAllocation(this.tableData[e.index].f_num,e);
                    });
                    return;
                }
                this.tableData[e.index].f_kpnum_sell=e.f_kpnum_sell;
                //this.tableData[e.index].f_num=(this.tableData[e.index].f_kpnum_sell/this.tableData[e.index].f_bl).toFixed(this.$setPrecision.quantityPrecision);
                this.tableData[e.index].ysordnum=(this.tableData[e.index].f_kpnum_sell/this.tableData[e.index].f_bl).toFixed(this.$setPrecision.quantityPrecision);
                this.tableData[e.index].f_amount=(this.tableData[e.index].ysordnum*this.tableData[e.index].f_price).toFixed(this.$setPrecision.quantityPrecision);
                this.handleAllocation(this.tableData[e.index].ysordnum,e);
                return;
                /*if(e.f_kpnum_sell>this.tableData[e.index].f_validnum||e.f_kpnum_sell==0){
                    this.$message.error('编辑开票数量不可大于原开票数量！');
                    this.tableData[e.index].f_kpnum_sell =this.tableData[e.index].f_validnum;
                    this.tableData[e.index].f_num = this.tableData[e.index].f_validnum / 1
                    this.$set(this.tableData,e.index,e)
                }else{
                    this.tableData[e.index].f_kpnum_sell = e.f_kpnum_sell;
                    let price = this.tableData[e.index].f_kpnum_sell * this.tableData[e.index].f_kpprice_sell;
                    this.tableData[e.index].f_amount = Math.round(parseFloat(price) * 100) / 100;
                    this.tableData[e.index].f_num = this.tableData[e.index].f_kpnum_sell / this.tableData[e.index].f_bl
                    /!*let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                    this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;*!/
                    this.$set(this.tableData,e.index,e)
                }*/
                //console.log( this.tableData[e.index].f_num,' this.tableData[e.index].f_num')

            },
            handleAllocation(ddnum,prow) {
                //console.log(ddnum,'ddnum')
                //this.loading2=true;
                let remaining = parseFloat(ddnum) || 0;
                //this.$refs.multipleTable.clearSelection();
                //this.masterSelectedList=[];
                //console.log(remaining,'remaining')
                this.tableData[prow.index].subDetails.forEach(row => {
                    //console.log(row,'row')
                    row.f_invoicenum=0;
                    row.f_ordernum=0;
                    //row.vc_unit=this.vc_unit;
                    //row.vc_kpunit_sell=this.vc_kpunit_sell;
                    //row.f_bl=this.f_bl;
                    const maxAvailable = parseFloat(row.f_ordernum_ky) || 0; // 当前行最大可关联量
                    //console.log('maxAvailable',maxAvailable)
                    let currentAllocated = 0;
                    if (remaining > 0) {
                        if (remaining >= maxAvailable) {
                            currentAllocated = maxAvailable;
                            remaining = parseFloat((remaining - maxAvailable).toFixed(this.$setPrecision.quantityPrecision));
                        } else {
                            currentAllocated = remaining;
                            remaining = 0;
                        }
                        //console.log('currentAllocated',currentAllocated)
                        //console.log('remaining',remaining)
                        let f_kpprice_sell = this.tableData[prow.index].f_price / this.tableData[prow.index].f_bl;
                        //console.log('f_kpprice_sell',f_kpprice_sell)
                        //row.f_kpprice_sell = Math.round(parseFloat(f_kpprice_sell) * 100) / 100;
                        row.f_kpprice_sell = parseFloat(f_kpprice_sell).toFixed(this.$setPrecision.quantityPrecision);
                        row.f_ordernum = currentAllocated.toFixed(this.$setPrecision.quantityPrecision);
                        row.f_invoicenum = parseFloat((row.f_ordernum*prow.f_bl).toFixed(this.$setPrecision.quantityPrecision));
                        row.f_invoice_amount=parseFloat(this.keepTwoDecimal(row.f_invoicenum*row.f_kpprice_sell));
                        row.f_invoice_amount_notax=parseFloat(this.keepTwoDecimal(this.preciseDiv(row.f_invoice_amount, parseFloat(1+row.f_sl))));
                        row.f_invoice_amount_tax=parseFloat(this.keepTwoDecimal(row.f_invoice_amount_notax*row.f_sl));
                        row.f_invoicenum_ky=parseFloat((row.f_ordernum*prow.f_bl).toFixed(this.$setPrecision.quantityPrecision));

                    } else {
                        row.f_ordernum =  0;
                        row.f_invoicenum = 0;
                        row.f_invoice_amount=0;
                        row.f_invoice_amount_notax=0;
                        row.f_invoice_amount_tax=0;
                        row.f_invoicenum_ky=0;
                    }
                });
                //this.loading2=false;


            } ,
            getUnits(row){
                //console.log(row,'22222');
                //this.copyvaildnum=row.f_num;
                this.copyvaildnum=row.f_num;
                this.getUnitList(row.vc_unit);
            },
            changeData(e){
                //console.log(e.vc_kpunit_sell);
                //this.formData.vc_kpunit_sell=e;
                if(this.unitData.length!=0){
                    let choo = this.unitData.filter(item=>{
                        return item.vc_unitsconvert == e.vc_kpunit_sell
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].f_bl=choo[0].f_bl;
                        let f_kpprice_sell = this.tableData[e.index].f_price / choo[0].f_bl;
                        //console.log('f_kpprice_sell',f_kpprice_sell)
                        //this.tableData[e.index].f_kpprice_sell = Math.round(parseFloat(f_kpprice_sell) * 100) / 100;
                        this.tableData[e.index].f_kpprice_sell = parseFloat(f_kpprice_sell).toFixed(this.$setPrecision.quantityPrecision);
                        let validnum =0;
                        validnum=this.copyvaildnum*choo[0].f_bl;
                        //console.log('validnum',validnum)
                        this.tableData[e.index].f_validnum =validnum;
                        this.tableData[e.index].f_kpnum_sell=this.tableData[e.index].f_validnum;
                        this.tableData[e.index].yskpnum=this.tableData[e.index].f_kpnum_sell;
                    //    this.tableData[e.index].f_num=(this.tableData[e.index].f_kpnum_sell/this.tableData[e.index].f_bl).toFixed(this.$setPrecision.quantityPrecision);
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                        this.handleAllocation(this.tableData[e.index].f_num,e);
                    }else{
                        this.tableData[e.index].f_bl=1;
                        this.tableData[e.index].f_kpprice_sell = this.tableData[e.index].f_price*1;
                        //console.log('this.copyvaildnum',this.copyvaildnum)
                        this.tableData[e.index].f_validnum =this.copyvaildnum;
                        this.tableData[e.index].f_kpnum_sell=this.copyvaildnum;
                        this.tableData[e.index].vc_kpunit_sell=this.tableData[e.index].vc_unit;
                        this.tableData[e.index].yskpnum=this.tableData[e.index].f_kpnum_sell;
                        this.tableData[e.index].f_num=(this.tableData[e.index].f_kpnum_sell/this.tableData[e.index].f_bl).toFixed(this.$setPrecision.quantityPrecision);
                        this.tableData[e.index].ysordnum=(this.tableData[e.index].f_kpnum_sell/this.tableData[e.index].f_bl).toFixed(this.$setPrecision.quantityPrecision);
                        //let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                        this.handleAllocation(this.tableData[e.index].ysordnum,e);
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()

                    })
                }

            },
            //单位换算
            async getUnitList(vc_unit){
                let param = {
                    i_mid:this.mid,
                    vc_originunit:vc_unit,
                };
                let res = await API.getUnitList(param);
                if (res.code == 1) {
                    this.unitData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //订单列表
            async getOrders(){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    "queryList":this.addData.arr,
                };
                var res = await API.getRelateOrderDetailList(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData =  res.data;
                    //this.tableTotal = res.data.total;
                    //console.log(this.tableData);
                    this.tableData.forEach(row => {
                        row.yskpnum=row.f_kpnum_sell;
                        row.ysordnum=row.f_num;
                        row.subDetails.forEach(item=>{
                           item.f_sl=row.f_sl;
                           item.f_kpprice_sell=row.f_kpprice_sell;

                        });
                    })
                    //console.log('this.tableData',this.tableData)
                    this.$nextTick(()=>{
                        if(res.data.total==1){
                            this.expend=true;
                            this.refreshTable()
                        }
                    });

                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            /*handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getOrders();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getOrders();
            },*/
            /*//获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getOrders();
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.getOrders();
            },*/
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            //除
            preciseDiv(dividend, divisor) {
                if (dividend && divisor) {
                    //console.log(dividend, "////", divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result, 'result------')
                    return result;
                }
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            //保存
            async saveForm(){
                //console.log(this.tableData,'this.tableData111')
                let num0 = this.tableData.some(item=>item.f_kpnum_sell==0);
                //console.log('num0',num0)
                if(num0){
                    this.$message.error(this.$t('saleInvoicing_invoiced_quantity_is_zero'));
                    return;
                }
                this.tableData.forEach(row=>{
                    row.subDetails = row.subDetails.map(item=>{
                        return {
                            i_ywid:item.i_id,
                            f_ordernum:item.f_ordernum,
                            f_invoicenum:item.f_invoicenum,
                            i_type:item.i_type,
                            dt_ywtime:item.dt_ywtime,
                            uniquekey:item.uniquekey,
                            f_transitloss_num:item.f_transitloss_num,
                            f_reject_num:item.f_reject_num,
                            f_outbound_num:item.f_outbound_num,
                            f_invoice_amount:item.f_invoice_amount,
                            f_invoice_amount_notax:item.f_invoice_amount_notax,
                            f_invoice_amount_tax:item.f_invoice_amount_tax,
                            f_order_amount:item.f_invoice_amount,
                            f_order_amount_notax:item.f_invoice_amount_notax,
                            f_order_amount_tax:item.f_invoice_amount_tax,
                        }
                    });
                    row.i_state=this.addData.i_state;
                    row.i_invoice_source=this.addData.i_invoice_source;
                })
                console.log(this.tableData,'this.tableData')
                //return
                //let alist=[];
                //alist.push(this.formData);
                this.disabled=true;
                this.loading=true;
                let param={
                    delSub:[],
                    list:this.tableData,
                    i_order_source:this.addData.i_order_source,
                };
                let res=await API.saveInvoice(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.$emit('close','new');
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('close');
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>



    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex_e{
        display: flex;
        justify-content: end;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
